export default {"src":"/_next/static/media/404.46737d25.svg","height":174,"width":340,"blurWidth":0,"blurHeight":0};